<template>
    <div class="text-secondary mb-3 note">
        Входя в личный кабинет пользователя, я подтверждаю, что даю <RouterLink to="/terms_of_use" target="_blank">согласие на обработку персональных
            данных</RouterLink>, сведений об абоненте и на получение кредитного отчета
    </div>
</template>